


export default function AccueilAdmin({visible}){
    return(
        (visible &&
            "accueil admin"
        )
    )
}